// Cross-component UI state (sidebar quick-view panels, viewport size).

class UiStore {
	/**
	 * Which quick-view panel is open: 'cart' | 'filter' | 'search' | '' | null
	 * @type {string | null}
	 */
	sideBarVisible = $state('');
	/** Viewport at or below 768px (kept in sync by SideBar.svelte). */
	isMobile = $state(false);

	/** @param {string} name */
	toggleQuickView(name) {
		this.sideBarVisible = this.sideBarVisible === name ? '' : name;
	}

	closeQuickView() {
		this.sideBarVisible = '';
	}
}

export const ui = new UiStore();
